export default "__VITE_ASSET__ddf025fe__"